<script setup>
  import {computed} from "vue";

  import {simpleAttributeText, simpleAttributeTitle} from "@pages/Patients/Components/PatientAttributes/Enums.js";

  defineOptions({
    name: "ComponentPatientSidebarSimpleAttribute",
  });

  const props = defineProps({
    attribute: {
      type: Object,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  });

  const attributeTitle = computed(() => simpleAttributeTitle[props.attribute.type] ?? null);
  const attributeText = computed(() => simpleAttributeText[props.attribute.type] ?? null);
</script>

<template>
  <div :class="{'flex flex-wrap space-x-1.5': inline}">
    <h6 class="text-gray-600" :class="{'font-semibold': inline, 'text-xs uppercase': !inline}">
      {{ attributeTitle }}{{ inline ? ":" : "" }}
      <slot name="label" />
    </h6>

    <div :class="{'mt-0.5 text-sm': !inline}">
      <slot>
        {{ attributeText }}
      </slot>
    </div>
  </div>
</template>
